import { QueryObserver } from '@tanstack/react-query';
import getCartQueryKey from '@nike/shop-apis/buy/carts/v2/get-query-key';
/**
 * Observes the cart store and notifies on cart updates.
 *
 * @param {Object} params
 * @param {function({ cart: { cart: Object } }): void} [params.onCartUpdateCallback] -
 *   Optional callback function that will be called whenever the cart data is updated.
 *   The callback receives `{ cart: { cart: cartData } }` — double-nested to match the
 *   legacy Redux state shape (`state[CART_STATE_KEY].cart`) that external consumers
 *   (e.g. SNKRS web) depend on. See MYBAG-5590.
 * @param {Object} params.shopInstance - The shop instance to use to access the public functions. Intentionally not using window.NikeShop to force instantiation of the shop instance to avoid potential timing issues.
 * @param {function({ cart: Object }): void} [params.shopInstance.get] - The public functions to use to access the public functions.
 */

export default function observeCartStore(_ref) {
  var onCartUpdateCallback = _ref.onCartUpdateCallback;
  var queryClient = window.NikeShop.__INTERNAL_USE__.queryClient;
  var cartQueryKey = getCartQueryKey();
  var observer = new QueryObserver(queryClient, {
    queryKey: cartQueryKey,
    // Prevent the observer from triggering its own fetch (no queryFn here).
    // It only needs to watch for cache updates from legitimate sources
    // (e.g. useFetchCart hook, NikeShop.fetchCart). Without this, the
    // observer's failed fetch enters retry mode and blocks external callers.
    enabled: false
  });
  observer.subscribe(function (result) {
    var cartData = result.data;
    if (!cartData) return;

    // Call custom callback if provided by consumer
    if (onCartUpdateCallback && typeof onCartUpdateCallback === 'function') {
      onCartUpdateCallback({
        cart: {
          cart: cartData
        }
      });
    }
  });
}